// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productShortNameForm[data-v-46c05950] {\n  padding: 20px 20px 0;\n}\n.content-box[data-v-46c05950] {\n  height: calc(100vh - 100px);\n  background: #fff;\n}\n.y-w-120[data-v-46c05950] {\n  width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
